// src/components/checkout_block_title.js
import React from 'react';
import {useTranslation} from "react-i18next";

const CheckoutBlockTitle = () => {
    const {t} = useTranslation();
    return (
        <div className="checkout_block_title">
            <p className="checkout_block_title_text bold">{t("checkout_block_title_text")}</p>
        </div>
    );
};

export default CheckoutBlockTitle;
